import { render, staticRenderFns } from "./SubmitForReview.vue?vue&type=template&id=6e425a66&"
import script from "./SubmitForReview.vue?vue&type=script&lang=js&"
export * from "./SubmitForReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports